import request from '@/utils/request'

export function getshoplist(query) {
	return request({
		url: 'api/getshoplist',
		method: 'get',
		params: query
	})
}

export function getshophistorylist(query) {
	return request({
		url: 'api/getshophistorylist',
		method: 'get',
		params: query
	})
}

export function doshop(query) {
	return request({
		url: 'api/doshop',
		method: 'post',
		data: query
	})
}


 

